export default [
  {
    path: '/',
    redirect: { name: 'login' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/leaderboard',
    name: 'leaderboard',
    component: () => import('../views/leaderboard.vue'),
    meta: {
      title: '排行榜'
    }
  },
  {
    path: '/departmentCompletion',
    name: 'departmentCompletion',
    component: () => import('../views/departmentCompletion.vue'),
    meta: {
      title: '完成情况'
    }
  },
  {
    path: '/manuscriptIndex',
    name: 'manuscriptIndex',
    component: () => import('../views/manuscriptIndex.vue'),
    meta: {
      title: '夺宝'
    }
  },
  {
    path: '/luckyDrawDetails',
    name: 'luckyDrawDetails',
    component: () => import('../views/luckyDrawDetails.vue'),
    meta: {
      title: '抽奖详情'
    }
  },
  {
    path: '/prizeManagement',
    name: 'prizeManagement',
    component: () => import('../views/prizeManagement.vue'),
    meta: {
      title: '奖品管理'
    }
  },
  {
    path: '/prizeClaimDetails',
    name: 'prizeClaimDetails',
    component: () => import('../views/prizeClaimDetails.vue'),
    meta: {
      title: '兑奖详情'
    }
  },
  {
    path: '/sweepstakesPage',
    name: 'sweepstakesPage',
    component: () => import('../views/sweepstakesPagecopy.vue'),
    meta: {
      title: '幸运抽奖活动'
    }
  },
  {
    path: '/quarterlyPrize',
    name: 'quarterlyPrize',
    component: () => import('../views/quarterlyPrize.vue'),
    meta: {
      title: '季度大奖'
    }
  },
  {
    path: '/individualCompletion',
    name: 'individualCompletion',
    component: () => import('../views/individualCompletion.vue'),
    meta: {
      title: '有奖互动'
    }
  },
  {
    path: '/personalDetails',
    name: 'personalDetails',
    component: () => import('../views/personalDetails.vue'),
    meta: {
      title: '个人明细'
    }
  },
  {
    path: '/zhishu',
    name: 'zhishu',
    component: () => import('../views/zhishu.vue'),
    meta: {
      title: '稿件指数'
    }
  },
  {
    path: '/zhishusecond',
    name: 'zhishusecond',
    component: () => import('../views/z2.vue'),
    meta: {
      title: '稿件指数'
    }
  },
  {
    path: '/writePlace',
    name: 'writePlace',
    component: () => import('../views/writePlace.vue'),
    meta: {
      title: '填写收货地址'
    }
  },
  {
    path: '/shop_home',
    name: 'shop_home',
    component: () => import('../views/shop/shop_home.vue'),
    meta: {
      title: '商家首页'
    }
  },
  {
    path: '/shop_list',
    name: 'shop_list',
    component: () => import('../views/shop/shop_list.vue'),
    meta: {
      title: '核销记录'
    }
  },
  {
    path: '/shop_hx_list',
    name: 'shop_hx_list',
    component: () => import('../views/shop/shop_hx_list.vue'),
    meta: {
      title: '待核销列表'
    }
  },
  {
    path: '/shop_tj',
    name: 'shop_tj',
    component: () => import('../views/shop/shop_tj.vue'),
    meta: {
      title: '统计分析'
    }
  },
  {
    path: '/point_mall',
    name: 'point_mall',
    component: () => import('../views/point_mall.vue'),
    meta: {
      title: '今日独家福利'
    }
  },
  {
    path: '/point_mall_detail',
    name: 'point_mall_detail',
    component: () => import('../views/point_mall_detail.vue'),
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/sweepstakesPagecopy',
    name: 'sweepstakesPagecopy',
    component: () => import('../views/sweepstakesPagecopy.vue'),
    meta: {
      title: '积分商城'
    }
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/list.vue'),
    meta: {
      title: '活动列表'
    }
  }
];
